import CometMarquee from 'comet-marquee';

const marqueeInstances = new WeakMap();
const pendingMarquees = new WeakSet();

const getMarquees = (scope) => {
  const root = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
  const marquees = Array.from(root.querySelectorAll('.clients-marquee'));

  if (root.matches?.('.clients-marquee')) {
    marquees.unshift(root);
  }

  return marquees;
};

const waitForImages = (images) => Promise.all(images.map((image) => {
  if (image.complete) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    image.addEventListener('load', resolve, { once: true });
    image.addEventListener('error', resolve, { once: true });
  });
}));

const createMarquee = (marqueeEl) => {
  if (marqueeInstances.has(marqueeEl)) {
    return;
  }

  const contentEl = marqueeEl.querySelector('.comet-marquee-content');
  const items = Array.from(contentEl?.children ?? []).filter(
    (item) => item.classList.contains('comet-marquee-item')
      && !item.classList.contains('comet-marquee-clone')
  );

  if (!contentEl || !items.length) {
    return;
  }

  marqueeEl.classList.remove('is-static');

  const marquee = new CometMarquee(marqueeEl, {
    speed: 40,
    pauseOnHover: true,
    initialShift: window.innerWidth >= 1033,
    pauseOnInvisible: true,
    syncPause: false,
    repeatCount: 5,
    forceAnimation: window.innerWidth >= 1033,
    forceAnimationWidth: window.innerWidth >= 1033 ? 3 : false,
    fadeEdges: true,
  });

  marqueeInstances.set(marqueeEl, marquee);
};

const initClientsMarquee = (scope = document) => {
  getMarquees(scope).forEach((marqueeEl) => {
    if (marqueeInstances.has(marqueeEl) || pendingMarquees.has(marqueeEl)) {
      return;
    }

    const images = Array.from(marqueeEl.querySelectorAll('img'));

    if (!images.some((image) => !image.complete)) {
      window.requestAnimationFrame(() => createMarquee(marqueeEl));
      return;
    }

    pendingMarquees.add(marqueeEl);
    waitForImages(images).then(() => {
      pendingMarquees.delete(marqueeEl);
      window.requestAnimationFrame(() => createMarquee(marqueeEl));
    });
  });
};

window.initClientsMarquee = initClientsMarquee;
initClientsMarquee();
